import { IMAGES_CDN_LINK } from "./links"

export const getAssetUrl = (assetPath: string, area: 'play-area' | 'website' = 'play-area'): string => {
    // local env
    if (process.env.NODE_ENV === 'development') {
        if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_PLAY_AREA_URL) {
            return `${process.env.NEXT_PUBLIC_PLAY_AREA_URL}/assets${assetPath}`
        }
        return `/assets${assetPath}`
    }

    // server
    return `${IMAGES_CDN_LINK}/assets/${area}${assetPath}`
}